// Lingue del sito. L'inglese è la lingua principale, senza prefisso (arkorb.com/launches); le altre hanno il loro
// prefisso e indirizzi tradotti (arkorb.com/it/lanci): ogni lingua è indicizzata da Google come pagina a sé.
// Decisione del 18 ott 2026 (pubblico mondiale); italiano completo; francese, tedesco e spagnolo dal 18 ott 2026.
// Per aggiungere una lingua: un dizionario con la stessa forma di it.ts (il controllo dei tipi segnala ciò che manca),
// una riga in LINGUE e i percorsi in PERCORSI.

import { de } from './de';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { it, type Dizionario } from './it';

import { LINGUA_PREDEFINITA, PERCORSI, type Lingua, type Sezione } from './percorsi';
export * from './percorsi';

const DIZIONARI: Record<Lingua, Dizionario> = { en, it, fr, de, es };

// Indirizzi tradotti, senza accenti (ASCII: più semplici da scrivere e da condividere).

let corrente: Lingua = LINGUA_PREDEFINITA;

export const lingua = (): Lingua => corrente;
export const t = (): Dizionario => DIZIONARI[corrente];
export const dizionario = (l: Lingua): Dizionario => DIZIONARI[l];

export function impostaLingua(l: Lingua): void {
  corrente = l;
  document.documentElement.lang = l;
}

/** Indirizzo di una sezione nella lingua corrente (o in quella indicata). */
export function indirizzo(sezione: Sezione, l: Lingua = corrente, coda = ''): string {
  return PERCORSI[sezione][l] + coda;
}
